import React from 'react'
import PropTypes from 'prop-types'
import Component from 'decorators/Component'
import Dialog from './Dialog'

class InformationalDialog extends React.PureComponent {
  static propTypes = {
    show: PropTypes.bool,
    header: PropTypes.any,
    body: PropTypes.any,
    onClose: PropTypes.func,
    confirmText: PropTypes.string,
    onConfirm: PropTypes.func,
    onClosed: PropTypes.func,
    subText: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element
    ]),
    footer: PropTypes.element,
    initialFocus: PropTypes.string
  }

  state = {
    confirming: false
  }

  static defaultProps = {
    show: false,
    onClose: () => {},
    onConfirm: x => x
  }

  handleAsyncConfirmClick = async (action) => {
    const { onClose } = this.props
    this.setState({ confirming: true })
    await action()
    this.setState({ confirming: false })
    onClose()
  }

  onConfirmButtonClick = async () => {
    const { onConfirm } = this.props
    await this.handleAsyncConfirmClick(onConfirm)
  }

  render () {
    const { t, header, body, subText, confirmText, footer, onConfirm, initialFocus, ...props } = this.props
    const { confirming } = this.state

    return (
      <Dialog
        {...props}
        initialFocus={initialFocus || '#confirmButton'}
        header={header}
        body={body}
        subText={subText}
        footer={footer}
        buttons={(
          <Dialog.Button
            id='confirmButton'
            disabled={confirming}
            loading={confirming}
            onClick={this.onConfirmButtonClick}>
            {confirmText || t('Okay')}
          </Dialog.Button>
        )}
      />
    )
  }
}

export default Component()(InformationalDialog)
